import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PanelSubHeading from "../../components/panel/subHeading";
import ProgressBar from "./charts/progressBar";
import { backend, Dates, statsBackend } from "../../services";
import { actions, RootState } from "../../state/reducer";
import { generateRandomString, getMonthAndYear } from "../../utils";
import { UserShortInfo } from "../../types";
import SetupSalePlanModal from "../../modals/stats/salePlanSetup";
import { closeModal, openModal } from "../../state/modalSlice";
import { defaultCurrencyId } from "../../constants";
import SalePlanNoCalcDiagram from "./planDiagreamNoCalc";

const usingCurrencyId = defaultCurrencyId;

const SalePlanHomeDiagram = (props: {
  userId?: number;
  dates?: Dates;
  enableSettings?: boolean;
  userInfo?: UserShortInfo;
}) => {
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const [saleAmount, setSaleAmount] = useState<number>(0);
  const [salePlan, setSalePlan] = useState<number>(0);
  const user_id = props?.userId || State.session?.id;
  const dates = props.dates || getMonthAndYear(new Date());
  const rights = State.rights;

  if (!user_id) {
    return null;
  }

  // Получаем текущий месяц и год
  const today = new Date();

  useEffect(() => {
    if (props?.userInfo) {
      statsBackend.getUserSalePlan(props.userInfo.id || user_id).then((res) => {
        setSalePlan(res.value);
      });
      statsBackend
        .getUserSaleAmount(props.userInfo.id || user_id, dates)
        .then((res) => {
          const saleAmount =
            res.stats.find((item) => item.currency_id === usingCurrencyId)
              ?.total_amount || 0;
          setSaleAmount(saleAmount);
        });
    } else {
      statsBackend.getLastSaleAmount().then((res) => {
        const saleAmount =
          res.stats.find((item) => item.currency_id === usingCurrencyId)
            ?.total_amount || 0;
        setSaleAmount(saleAmount);
      });
      statsBackend.getPersonalSalePlan().then((res) => {
        setSalePlan(res.value);
      });
    }
  }, [rights, State.selectedItem]);

  const handleOpenSetupModal = () => {
    const user = props.userInfo;
    if (!user) {
      return null;
    }
    dispatch(
      openModal({
        component: SetupSalePlanModal,
        context: {
          user,
          onSave: () => {
            dispatch(actions.selectItem(generateRandomString(4)));
          },
          closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
        },
      })
    );
  };

  if (!salePlan) {
    return null;
  }

  return (
    <SalePlanNoCalcDiagram
      enableSettings={!!props.enableSettings}
      month={today.getMonth()}
      year={today.getFullYear()}
      fact={saleAmount}
      plan={salePlan}
      title={`План продаж${props.userInfo ? ` - ${props.userInfo.name}` : ""}`}
      onOpenModal={props.userInfo ? handleOpenSetupModal : undefined}
    />
  );
};

export default SalePlanHomeDiagram;
